import React, {FunctionComponent, useState} from "react"
import Button from "@murphy-frontend/web-core/components/Button"

interface TemplateConfirmProps {
	incident: string
	templateId: number
	customerId: string
	handleCreate: (template: number) => void
	closeModal: () => void
	translations: Record<any, any>
}

const TemplateConfirmModal: FunctionComponent<TemplateConfirmProps> = ({
	incident,
	closeModal,
	templateId,
	handleCreate,
	translations
}) => {
	const [isLoading, setIsLoading] = useState(false)

	const handleClick = () => {
		setIsLoading(true)
		handleCreate(templateId)
	}

	return (
		<div className='template-modal'>
			<h4>{`${translations.incidentModalTitle} ${incident}?`}</h4>
			<p>{translations.incidentModalDesc}</p>
			<div className='row field-add-user-btns'>
				<Button
					buttonStyle={"btn--outline"}
					isNeutralButton={true}
					buttonSize={"btn--medium"}
					onClick={closeModal}
					customClasses={"temp-btn"}
				>
					{translations.no}
				</Button>
				<Button buttonSize={"btn--medium"} isLoading={isLoading} onClick={handleClick} customClasses={"temp-btn"}>
					{translations.yes}
				</Button>
			</div>
		</div>
	)
}

export default TemplateConfirmModal
